module.exports = __webpack_public_path__ + "img/image4.b836e50c.jpg";